
import React, { Component } from 'react';
import Keycloak from 'keycloak-js';
import auth from './Auth';
import { Switch, Route,  NavLink, HashRouter, Redirect } from 'react-router-dom';
import {bindActionCreators} from "redux";
import * as Actions from "../actions/index";
import {connect} from "react-redux";

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            keycloak: null,
            authenticated: false
        }
    }


    componentDidMount() {

        let config =window.config;
        let {actions} = this.props;
        // keycloak-js 26 requires explicit url / realm / clientId
        const keycloak = new Keycloak({
            realm: config.config_keycloak.realm,
            url: config.config_keycloak.url || config.config_keycloak["auth-server-url"],
            clientId: config.config_keycloak.resource || config.config_keycloak.clientId,
        });


        if (this.props.location.state !== undefined){
            location.href = location.href + "?redirect=" + this.props.location.state.from.pathname + this.props.location.state.from.search;
            actions.addSearchParameters(this.props.location.state.from.search);
            //return <Redirect to={this.props.location.state.from.pathname}/>
        }


        keycloak
            .init({
                onLoad: 'login-required',
                pkceMethod: 'S256',
                // Avoid session-iframe loops with cross-origin Keycloak (v26+)
                checkLoginIframe: false,
            })
            .then(authenticated => {
                this.setState({ keycloak: keycloak, authenticated: authenticated });
                let appState = {
                    authenticated: authenticated,
                    keycloak: keycloak
                };
                auth.setToken(appState);
                actions.addAuthorization(keycloak);
                this.props.history.push(window.location.href.split("redirect=")[1])
            })
            .catch((e) => {
                console.error('keycloak init exception:', e);
                this.setState({ keycloak: keycloak, authenticated: false });
            });
    }

    render() {
        if (this.state.keycloak) {
            if (this.state.authenticated) {
                //{this.renderRedirect()}

                return (<div>protected page</div>


                )
            } else return (<div>Unable to authenticate!</div>)
        }
        return (
            <div>Loading page</div>
        );
    }
}




function mapStateToProps (state) {
    return {
        authorization: state.authorization
    }
}

const mapDispatchToProps = (dispatch) => ({
    actions: bindActionCreators(Actions, dispatch)
});



//export default Login;

export default connect(mapStateToProps,mapDispatchToProps)(Login);
